import React, { useState } from 'react';
import PropTypes from 'prop-types';

import './ImagewithFallback.scss';

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==';

export default function ImageWithFallback({
  src=ERROR_IMG_SRC, alt='Image', style={}, className='', loading = 'lazy', decoding = 'async', ...rest
}) {
  const [didError, setDidError] = useState(false);

  const handleError = () => {
    setDidError(true);
  };

  const isValidSrc = typeof src === 'string' && src.trim() !== '';

  return didError || !isValidSrc ? (
    <div className={`imageFallbackContainer ${className || ''}`} style={style}>
      <div className="imageFallbackContent">
        <img 
          src={ERROR_IMG_SRC} alt="Error loading" className="fallbackImage" loading={loading} decoding={decoding}
          data-original-url={src} {...rest} 
        />
      </div>
    </div>
  ) : (
    <img src={src} alt={alt} loading={loading} decoding={decoding} className={className} style={style} onError={handleError} {...rest} />
  );
};

ImageWithFallback.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  loading: PropTypes.string,
  decoding: PropTypes.string,
};
